import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import Review from "./Review";
import {getPdfReport, getTeamMembers} from "../../api";
import {withRouter} from "react-router-dom";
import {Col, Grid, Row} from "react-flexbox-grid";
import {isCreatorOrAdministrator, isExternalContributor, isViewOnly} from "../../utils/UserInfo";
import Button from "../../components/Button";
import Errors from "../../components/Errors";
import UndoPopUp from "../../components/UndoPopUp";
import {confirmAlert} from "react-confirm-alert";
import PdfReport from "../common/pdf";

const pdfButton = {
    style: {
        backgroundColor: '#0CA0DA',
        color: 'white',
        fontWeight: 'bold',
        height: '41px',
    }
}

class ClosedReview extends Component {
    constructor(props) {
        super(props);
        this.handleExit = this.handleExit.bind(this);
        this.handleEditProject = this.handleEditProject.bind(this);
        this.handleEditTeam = this.handleEditTeam.bind(this);
        this.handleViewAsset = this.handleViewAsset.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
        this.closeErrorBox = this.closeErrorBox.bind(this);
    }

    state = {
        error: null,
        project: this.props.project,
        teams: [],
        teamUserId:{},
        dataPdfReport:"",
        pdfBtn:false,
    };

    handleEditProject() {
        this.props.history.push(`/closed/${this.props.project.id}/details`);
    }
    handleEditTeam(){
        this.props.history.push(`/closed/${this.props.project.id}/team`);
    }
    handleViewAsset(){
        this.props.history.push(`/closed/${this.props.project.id}/assetsummary`);

    }

    handleErrors(error){
        this.setState({error});
        window.scrollTo(0,0);
    }

    closeErrorBox(){
        const error = null;
        this.setState({error});
    }

    /**
     * Exit project Overview and set to "Closed".
     */
    async handleExit() {
        this.props.history.push(`/dashboard/closed`);
    }

    render() {
        return (
            <Grid fluid>
                <Errors error={this.state.error}
                        onCloseBox={this.closeErrorBox} />
                <Row>
                    <Review
                        project={this.props.project}
                        onEditProject={this.handleEditProject}
                        onEditTeam={this.handleEditTeam}
                        onViewAsset={this.handleViewAsset}
                        teamMembers={this.props.teamMembers}
                    />
                </Row>

                <Row className="projdtls-button" style={{marginTop: '16px'}}>
                    <Col xs={12} style={{marginLeft: "-15px"}}>
                            { isCreatorOrAdministrator() &&
                            <UndoPopUp
                                style={{marginLeft: '20px'}}
                                project={this.props.project}
                                history={this.props.history}
                                context={this.props.context}
                                undoStatus={"Undo Closed Project"}/>
                            }
                        <PdfReport project={this.props.project}/>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

ClosedReview.contextType = CommToolContext;
export default withRouter(ClosedReview);

